import { FC } from 'react';
import { RecommendationBlockStoryblok } from 'storyblok-types';
import { getStoriesByPrefix } from 'commerce/storyblok/api';
import { IServerProps } from '../types';
import { RecommendationBlockBody } from './RecommendationBlockBody';
import { getToplisteStoryName } from './utils';

export const RecommendationBlock: FC<{
  blok?: RecommendationBlockStoryblok;
  serverProps?: IServerProps;
}> = async ({ blok, serverProps }) => {
  const randomToplistePage = blok?.randomToplistePage;
  let randomToplistePageData;

  /** if randomToplistePage is true  we fetch topliste pages from storyblok
   * and use its data to display title and link in recommendstion block
   *
   * if randomToplistePage is false we use title and link which was configured
   * in storyblok
   */
  if (randomToplistePage) {
    const { response, error } = await getStoriesByPrefix(
      serverProps?.params.locale || 'de',
      'topliste',
    );

    if (error) {
      console.error('No topliste stories');
      return;
    }

    const stories = response?.data.stories || [];
    /** get random story from the stories list */
    const story = stories[Math.floor(Math.random() * stories.length)];

    randomToplistePageData = {
      title: getToplisteStoryName(story.name),
      link: story.full_slug,
    };
  }

  return !blok ? null : (
    <RecommendationBlockBody
      blok={{
        ...blok,
        title: randomToplistePage ? randomToplistePageData?.title : blok?.title,
        link: randomToplistePage ? randomToplistePageData?.link : blok?.link,
      }}
    />
  );
};
